
import React, { useState } from 'react'

/**
 * useLocalStorage returns a value from local storage using the
 * given key, with optional default. Values are serialized as JSON.
 */

export default function useLocalStorage(key, defaultValue = undefined) {
  const [value, setValue] = useState(_ => get(key, defaultValue))

  function update(value) {
    setValue(value)
    set(key, value)
  }

  return [value, update]
}

/**
 * get a local storage value.
 */

function get(key, defaultValue = undefined) {
  try {
    return JSON.parse(localStorage[key])
  } catch (err) {
    return defaultValue
  }
}

/**
 * set a local storage value.
 */

function set(key, value) {
  localStorage[key] = JSON.stringify(value)
}